import React from "react"
import illustration from '../../pageComponents/images/page16/illustration-mobile.svg'

const Page17Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div>
          <div className='mt-2 font-26 font-family-acumin line-height-32 font-weight-500'>
            Porta la tua flotta verso un futuro più sostenibile,
            grazie al supporto completo del progetto Fleet Audit
          </div>
          <div className='mt-2 font-20 line-height-26'>
            Il report del servizio di Edison aiuta a dimensionare nel modo corretto
            la propria flotta aziendale, a comprendere e risolvere le inefficienze di mobilità,
            e a conoscere i viaggi e i veicoli sostituibili. Con Fleet Audit è poi possibile
            conoscere il risparmio di carburante e CO2 emessa in caso di sostituzione, e
            progettare correttamente le infrastrutture di ricarica.
          </div>
          <div className='mt-4 text-center'>
            <img src={illustration} alt='Illustration'/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page17Mobile
